import { render, staticRenderFns } from "./addMenu.vue?vue&type=template&id=c9abbce2&scoped=true&"
import script from "./addMenu.vue?vue&type=script&lang=js&"
export * from "./addMenu.vue?vue&type=script&lang=js&"
import style0 from "./addMenu.vue?vue&type=style&index=0&id=c9abbce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9abbce2",
  null
  
)

export default component.exports